import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
    const { userInfo, accessToken } = useSelector(state => state.user);
    let location = useLocation()

    return userInfo?.email && userInfo?.uid && accessToken ? (
        children
    ) : (
        <Navigate to="/auth" state={{ from: location }} />
    )
};

export default PrivateRoute;